import { type ConvertedVideo, convertVideo, type VideoContainer } from "./convertVideo";

export interface TrimVideoOptions {
  /** Start of the kept region, in seconds. */
  start: number;
  /** End of the kept region, in seconds. */
  end: number;
  /** Output container. Defaults to MP4. */
  format?: VideoContainer;
  /** Progress callback, 0–1. */
  onProgress?: (progress: number) => void;
}

export type TrimmedVideo = ConvertedVideo;

/**
 * Trim a video to `[start, end]` and return a new file. Thin wrapper over
 * {@link convertVideo}: the video stream is copied (no re-encode) when the
 * codecs fit the chosen container.
 */
export function trimVideo(file: Blob, options: TrimVideoOptions): Promise<TrimmedVideo> {
  return convertVideo(file, {
    format: options.format ?? "mp4",
    trim: { start: options.start, end: options.end },
    ...(options.onProgress ? { onProgress: options.onProgress } : {}),
  });
}
